// extracted by mini-css-extract-plugin
module.exports = {"hr":"HorizontalRule_hr__FU_vY"};